import { Book } from '@phosphor-icons/react';

export default Book;
